export default function PickFromChoicesCtrl($mdDialog) {
    "ngInject";
    var vm = this;

    vm.close = $mdDialog.cancel;
}
